
export enum ReportType {
    "other" = 1, 
    "visitorPass" = 2, 
};
export const ReportTypeValues = Object.keys(ReportType).filter((item) => {
    return isNaN(Number(item));
});
export enum ReportState {
    "none" = 1,
    "pending" = 2,
    "uploading" = 3,
    "extractingAudio" = 4,
    "transcripting" = 5,
    "extractingInformations" = 6,
    "done" = 7,
    "error" = 8,
}
export const ReportStateValues = Object.keys(ReportState).filter((item) => {
    return isNaN(Number(item));
});

export type Report = {
    id: number;
    guid: string;
    notes?: string;
    state: ReportState;
    type: ReportType;
    createdAt: Date;
}